import { render, staticRenderFns } from "./BoStaticSeo.vue?vue&type=template&id=21af1bb6&"
import script from "./BoStaticSeo.vue?vue&type=script&lang=js&"
export * from "./BoStaticSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports